import { render, staticRenderFns } from "./_Fichiers.vue?vue&type=template&id=b8f94458&scoped=true&"
import script from "./_Fichiers.vue?vue&type=script&lang=ts&"
export * from "./_Fichiers.vue?vue&type=script&lang=ts&"
import style0 from "./_Fichiers.vue?vue&type=style&index=0&id=b8f94458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f94458",
  null
  
)

export default component.exports